import * as THREE from 'three'
import * as ZapparThree from '@zappar/zappar-threejs'

import FS from './fragment'
import VS from './vertex'

// import { Pane } from 'tweakpane'




class SamplerMaterial extends THREE.ShaderMaterial {
  private uCameraWorldMatrixInverse: THREE.Matrix4 = new THREE.Matrix4()

  private uImageTrackerWorldMatrix: THREE.Matrix4 = new THREE.Matrix4()

  public constructor() {
    super({
      uniforms: {
        uCameraTexture: { value: new THREE.Texture() },
        uCameraTextureMatrix: { value: new THREE.Matrix4() },
        uResolution: { value: new THREE.Vector3() },
        uCameraWorldMatrixInverse: { value: new THREE.Matrix4() },
        uImageTrackerWorldMatrix: { value: new THREE.Matrix4() },
        uUvMultiplierX: { value: 1.42 },
        uUvMultiplierY: { value: 1.42 },
        uUvOffsetX: { value: 0.93 },
        uUvOffsetY: { value: 0.407 },

        //Test1
        // uUvMultiplierX: { value: 1.9 },
        // uUvMultiplierY: { value: 1.9 },
        // uUvOffsetX: { value: 0.08},
        // uUvOffsetY: { value: 0.28},


        //Test2
        // uUvMultiplierX: { value: 1.8 },
        // uUvMultiplierY: { value: 1.8 },
        // uUvOffsetX: { value: 1.115},
        // uUvOffsetY: { value: 0.31},

       
           //Test3
          //  uUvMultiplierX: { value: 0.665 },
          //  uUvMultiplierY: { value: 0.68 },
          //  uUvOffsetX: { value: 0.288},
          //  uUvOffsetY: { value: 1.195},
        
        

        // ...THREE.UniformsUtils.merge([
        //   THREE.UniformsLib['lights'],
        //   {
        //     lightIntensity: { type: 'f', value: 1.0 },
        //   },
        // ]),
      },
      vertexShader: VS,
      fragmentShader: FS,
      // lights: true,
      // transparent: true,
    })

    // const pane = new Pane({ title: 'Shader' })
    // pane.addInput(this.uniforms.uUvMultiplierX, 'value', {
    //   step: 0.0001,
    //   max: 3,
    //   min: 0,
    //   label: 'uUvMultiplierX',
    // })
    // pane.addInput(this.uniforms.uUvMultiplierY, 'value', {
    //   step: 0.0001,
    //   max: 3,
    //   min: 0,
    //   label: 'uUvMultiplierY',
    // })

    // pane.addInput(this.uniforms.uUvOffsetX, 'value', {
    //   step: 0.0001,
    //   max: 3,
    //   min: 0,
    //   label: 'uUvOffsetX',
    // })
    // pane.addInput(this.uniforms.uUvOffsetY, 'value', {
    //   step: 0.0001,
    //   max: 3,
    //   min: 0,
    //   label: 'uUvOffsetY',
    // })

    // const mat = this
    // console.log({ this: mat })
  }

  public render(
    camera: ZapparThree.Camera,
    copyPassTexture: THREE.Texture,
    renderer: THREE.WebGLRenderer,
    trackerGroup: ZapparThree.ImageAnchorGroup | ZapparThree.FaceAnchorGroup
  ) {
    this.uniforms.uCameraTexture.value = copyPassTexture
    this.uniforms.uCameraTextureMatrix.value = copyPassTexture.matrix

    camera.updateMatrixWorld()

    trackerGroup.updateMatrixWorld()
    this.uImageTrackerWorldMatrix.copy(trackerGroup.matrixWorld)
    this.uCameraWorldMatrixInverse.copy(camera.matrixWorldInverse)

    this.uniforms.uCameraWorldMatrixInverse.value =
      this.uCameraWorldMatrixInverse
    this.uniforms.uImageTrackerWorldMatrix.value = this.uImageTrackerWorldMatrix

    this.uniforms.uResolution.value.set(
      renderer.domElement.width * renderer.getPixelRatio(),
      renderer.domElement.height * renderer.getPixelRatio()
    )

    this.uniformsNeedUpdate = true
  }
}

export default SamplerMaterial
